import { ChangeDetectorRef, Component, ElementRef, ViewChild } from '@angular/core';
import { FormGroup, FormControl, AbstractControl, ValidationErrors } from '@angular/forms';
import { ProformaRepository } from 'src/app/proforma/domain/proforma.repository';
import { ComercialRepository } from 'src/app/repositorio/comercial.repository';
import { Parametros } from 'src/app/services/domain/services-domain';
import { StorageService } from 'src/app/services/storage.service';
import { UtilService } from 'src/app/services/util.service';
import { newmetadate } from 'src/app/shared/components/datatable/domain/datatable-domain';
import { ConsultarDireccionEntidadRequest, ListarArchivoEntidadRequest, ListarAuditoriaRequest, ListarEntidadesRequest, ListarUbigeosRequest, SincronizarEntidadSapRequest, TablaDireccionEntidad, TablaEntidadBloqueo, TransaccionEntidadBloqueoRequest, ValidarDocIdentidadRequest } from '../../../domain/request/mantenimiento-request';
import { ConfirmationService, MessageService, SelectItem } from 'primeng/api';
import { ComisionesRepository } from 'src/app/comisiones/domain/Comisiones-repository';
import { lisPais } from 'src/app/proforma/domain/response/proforma_response';
import { ListarTiposRequest } from 'src/app/statement-carrier/domain/request/statement-carrier-request';
import { sunatRequest } from 'src/app/proforma/domain/request/proforma_request';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { SelectedItems } from 'src/app/services/SelectedItems';

@Component({
  selector: 'app-page-mant-customer-service',
  templateUrl: './page-mant-customer-service.component.html',
  styleUrls: ['./page-mant-customer-service.component.css'],
  providers: [MessageService],
  standalone: false
})
export class PageMantCustomerServiceComponent {
  constructor(private readonly mantcomercial: ComercialRepository,
    private readonly storage: StorageService,
    private util: UtilService,
    private readonly comisiones: ComisionesRepository,
    private readonly proformaService: ProformaRepository,
    private messageService: MessageService,
    private readonly router: Router,
    private readonly title: Title,
    private cdr: ChangeDetectorRef,
    private confirmationService: ConfirmationService,
  ) {
    this.title.setTitle('Mantenimiento de Customer Service');
  }

  fechaActual: Date = new Date();
  codigoEntidad: number = 4
  group: FormGroup
  groupPoppupDG: FormGroup
  groupPoppupD: FormGroup
  groupPoppupE: FormGroup
  dataTable: any[] = []
  dataTableAuditoria: any[] = []
  dataTableDireccion: any[] = []
  dataTableArchivos: any[] = []
  visible: boolean
  juridica: boolean
  natural: boolean
  visiblebtn: boolean
  ListaTodosTipoDoc: any[] = []
  ListaTodosFechaTarifa: any[] = []
  ListaTodosMoneda: any[] = []
  listPais: lisPais[] = [];
  listDepartamento: any[] = [];
  listProvincia: any[] = [];
  listDistrito: any[] = [];
  ListaTodosTipoEntidad: any[] = []
  ListaTodosTipoAcuerdo: any[] = []
  tipo: any[] = []
  sexo: any[] = []
  atributos: any[] = []
  entcCod: number
  listaDatosEntidad: any = [];
  estadoEditar: boolean = true;
  ListaRegimenDP: SelectItem[] = []
  ListaTraficoDP: SelectItem[] = []
  ListaTipoEntidadDP: SelectedItems[] = []
  ListaTipoRelacionDP: SelectedItems[] = []
  ListaNombreEntidadesDP: SelectedItems[] = []
  ListaFiltradaNombreEntidadesDP: SelectedItems[] = []
  ListaFiltradaTipoEntidadDP: SelectedItems[] = []
  ListaMonedaDP: SelectedItems[] = []
  ListaBaseDP: SelectedItems[] = []
  heightView: number = window.innerHeight - 182;

  metadataTable: newmetadate[] = [
    { title: 'Sincronizar SAP', field: '', inputType: 'buttonPersonalizado', icon: 'pi pi-user', loading: false, function: (row: any) => this.sincronizarSAP(row), style: { align: "center" } },
    { field: 'entC_Codigo', title: 'Código', inputType: 'text' }, { field: 'tipO_CodTDI', title: 'Tipo Doc. Iden.', inputType: 'text' },
    { field: 'entC_DocIden', title: 'N.I.T', inputType: 'text' }, { field: 'entC_RazonSocial', title: 'Nombre', inputType: 'text' },
    { field: 'entC_Activo', title: 'Activo', inputType: 'checkbox' }, { field: 'entC_EMail', title: 'Correo', inputType: 'text' },
    { field: 'entC_EmailReceptorFE', title: 'Correo Factura Electrónica', inputType: 'text' }, { field: 'entC_Telef1', title: 'Tel. Fijo', inputType: 'text' },
    { field: 'entC_Telef2', title: 'Tel. Móvil', inputType: 'text' }, { field: 'entC_CodSAP_C', title: 'Cliente SAP', inputType: 'text' },
    { field: 'entC_CodSAP_P', title: 'Proveedor SAP', inputType: 'text' }, { field: 'entC_FecActSAP', title: 'Sincronización SAP', inputType: 'datetime' },
    { field: 'audI_UsrCrea', title: 'Creado por', inputType: 'text' }, { field: 'audI_FecCrea', title: 'Fecha crea', inputType: 'datetime' },
    { field: 'audI_UsrMod', title: 'Modificado por', inputType: 'text' }, { field: 'audI_FecMod', title: 'Fecha mod.', inputType: 'datetime' }
  ]

  metadataTableAuditoria: newmetadate[] = [
    { field: 'operacion', title: 'Operación', inputType: 'text' }, { field: 'direccionip', title: 'Dirección IP', inputType: 'text' },
    { field: 'nombremaquina', title: 'Nombre Máquina', inputType: 'text' }, { field: 'nombreaplicacion', title: 'Nombre Aplicación', inputType: 'text' },
    { field: 'usuariosql', title: 'Usuario SQL', inputType: 'text' }, { field: 'usuarioaplicacion', title: 'Usuario Aplicación', inputType: 'text' },
    { field: 'fechamodificacion', title: 'Fecha Modificación', inputType: 'datetime' }, { field: 'codigoentidad', title: 'Código Entidad', inputType: 'text' },
    { field: 'docidentidad', title: 'Doc. Identidad', inputType: 'text' }, { field: 'codigodocidentidad', title: 'Código Doc. Iden.', inputType: 'text' },
    { field: 'numdocidentidad', title: 'Num. Doc. Identidad', inputType: 'text' }, { field: 'tipopersona', title: 'Tipo Persona', inputType: 'text' },
    { field: 'domiciliado', title: 'Domiciliado', inputType: 'checkbox' }, { field: 'nombres', title: 'Nombres', inputType: 'text' },
    { field: 'apellidopaterno', title: 'Ape. Paterno', inputType: 'text' }, { field: 'apellidomaterno', title: 'Ape. Materno', inputType: 'text' },
    { field: 'nombrecompleto', title: 'Nom. Completo', inputType: 'text' }, { field: 'nombrecomercial', title: 'Nom. Comercial', inputType: 'text' },
    { field: 'razonsocial', title: 'Razón Social', inputType: 'text' }, { field: 'activo', title: 'Activo', inputType: 'checkbox' },
    { field: 'fechanacimiento', title: 'Fec. Nacimiento', inputType: 'datetime' }, { field: 'fechaingreso', title: 'Fec. Ingreso', inputType: 'datetime' },
    { field: 'vip', title: 'VIP', inputType: 'checkbox' }, { field: 'notas', title: 'Notas', inputType: 'text' },
    { field: 'sexo', title: 'Sexo', inputType: 'text' }, { field: 'email', title: 'E-mail', inputType: 'text' },
    { field: 'email2', title: 'E-mail2', inputType: 'text' }, { field: 'web', title: 'Web', inputType: 'text' },
    { field: 'propio', title: 'Propio', inputType: 'checkbox' }, { field: 'telefono1', title: 'Teléfono 1', inputType: 'text' },
    { field: 'telefono2', title: 'Teléfono 2', inputType: 'text' }, { field: 'telefono3', title: 'Teléfono 3', inputType: 'text' },
    { field: 'telefono4', title: 'Teléfono 4', inputType: 'text' }, { field: 'beneficiario', title: 'Beneficiario', inputType: 'text' },
    { field: 'area', title: 'Área', inputType: 'text' }, { field: 'cargo', title: 'Cargo', inputType: 'text' },
    { field: 'cuentausuario', title: 'Cuenta Usuario', inputType: 'text' }, { field: 'pais', title: 'País', inputType: 'text' },
    { field: 'codigopais', title: 'Cod. País', inputType: 'text' }, { field: 'holding', title: 'Holding', inputType: 'text' },
    { field: 'codigoholding', title: 'Cod. Holding', inputType: 'text' }, { field: 'tipotarifa', title: 'Tipo Tarifa', inputType: 'text' },
    { field: 'codigotarifa', title: 'Cod. Tarifa', inputType: 'text' }, { field: 'prospecto', title: 'Prospecto', inputType: 'checkbox' },
    { field: 'rebate', title: 'Rebate', inputType: 'decimal' }, { field: 'moneda', title: 'Moneda', inputType: 'text' },
    { field: 'codigomoneda', title: 'Cod. Moneda', inputType: 'text' }, { field: 'tipodeposito', title: 'Tipo Depósito', inputType: 'text' },
    { field: 'codtipodeposito', title: 'Cod. Tipo Depósito', inputType: 'text' }, { field: 'tarja', title: 'Tarja', inputType: 'decimal' },
    { field: 'realizatarja', title: 'Realiza Tarja', inputType: 'checkbox' }, { field: 'diacredito', title: 'Día Crédito', inputType: 'int' },
    { field: 'fechacredito', title: 'Fec. Crédito', inputType: 'datetime' }, { field: 'codigoaduana', title: 'Cod. Aduana', inputType: 'text' },
    { field: 'observaciones', title: 'Observaciones', inputType: 'text' }, { field: 'cuenintersoles', title: 'Cuen. Inter. Soles', inputType: 'text' },
    { field: 'cueninterdolares', title: 'Cuen. Inter. Dólares', inputType: 'text' }, { field: 'cuendetraccion', title: 'Cuen. Detracción', inputType: 'text' },
    { field: 'serviciologistico', title: 'Servicio Logístico', inputType: 'checkbox' }, { field: 'ocultarshipper', title: 'Ocultar Shipper', inputType: 'checkbox' },
    { field: 'obserfinanzas', title: 'Obser. Finanzas', inputType: 'text' }, { field: 'otrostraficos', title: 'Otros Tráficos', inputType: 'checkbox' },
    { field: 'mandato', title: 'Mandato', inputType: 'checkbox' }, { field: 'sli', title: 'SLI', inputType: 'checkbox' },
    { field: 'exportacion', title: 'Exportación', inputType: 'checkbox' }, { field: 'emailfinanzas', title: 'E-mail Fnanzas', inputType: 'text' },
    { field: 'bloqueocliente', title: 'Bloqueo Cliente', inputType: 'text' }, { field: 'usubloqueacliente', title: 'Usu Bloquea Cliente', inputType: 'text' },
    { field: 'fecbloqueocliente', title: 'Fec. Bloqueo Cliente', inputType: 'datetime' }, { field: 'obserbloqueocliente', title: 'Obser. Bloqueo Cliente', inputType: 'text' },
    { field: 'bloqueoproveedor', title: 'Bloqueo Proveedor', inputType: 'checkbox' }, { field: 'usubloqueaproveedor', title: 'Usu. Bloquea Proveedor', inputType: 'text' },
    { field: 'fecbloqueoproveedor', title: 'Fec. Bloqueo Proveedor', inputType: 'datetime' }, { field: 'obserbloqueoproveedor', title: 'Obser. Bloqueo Proveedor', inputType: 'text' },
    { field: 'obserproveedor', title: 'Obser. Proveedor', inputType: 'text' }, { field: 'asumedetraccion', title: 'Asume Detracción', inputType: 'checkbox' },
    { field: 'usuariocrea', title: 'Usuario Crea', inputType: 'text' }, { field: 'fechacrea', title: 'Fecha Crea', inputType: 'datetime' },
    { field: 'usuariomodifica', title: 'Usuario Modifica', inputType: 'text' }, { field: 'fechamodifica', title: 'Fecha Modifica', inputType: 'datetime' }
  ]

  parametros: Parametros[] = []
  async ListarParametros() {
    this.parametros = await this.util.getParametros()
    this.tipo = [{ name: 'Jurídica', key: 'J' }, { name: 'Natural', key: 'N' }];
    this.sexo = [{ name: 'Femenino', key: 'F' }, { name: 'Masculino', key: 'M' }];
    this.listPais = this.parametros.slice().filter(r => r.tipo === 'PAI')
    this.ListaTodosTipoDoc = this.parametros.slice().filter(r => r.tipo === 'TIPODOC')
    this.ListaTodosFechaTarifa = this.parametros.slice().filter(r => r.tipo === 'FECTARIFA')
    this.ListaTodosMoneda = this.parametros.slice().filter(r => r.tipo === 'MONEDA')
    this.ListaTodosTipoEntidad = this.parametros.slice().filter(r => r.tipo === 'TIPE')
    this.ListaTodosTipoAcuerdo = this.parametros.slice().filter(r => r.tipo === 'ACU')
    // listas de los dropdowns dentro del datatable
    this.parametros.map(r => {
      if (r.tipo === 'RGM') {
        const item = { label: r.nombre, value: r.codigo }
        this.ListaRegimenDP.push(item)
      }
      if (r.tipo === 'TRF') {
        const item = { label: r.nombre, value: r.codigo }
        this.ListaTraficoDP.push(item)
      }
      if (r.tipo === 'TIPO_ENTIDAD') {
        const item = { label: r.nombre, value: r.codigo }
        this.ListaTipoEntidadDP.push(item)
      }
      if (r.tipo === 'RELA_TIPOS') {
        const item = { label: r.nombre, value: r.codigo, key: r.adicional1 }
        this.ListaTipoRelacionDP.push(item)
      }
      if (r.tipo === 'AGE' || r.tipo === 'CONTACTO' || r.tipo === 'CUS' || r.tipo === 'DepositoVacio'
        || r.tipo === 'DepositoTemp' || r.tipo === 'EJEC' || r.tipo === 'TRANSPORTISTA') {
        const item = { label: r.nombre, value: r.codigo, tipo: r.tipo }
        this.ListaNombreEntidadesDP.push(item)
      }
      if (r.tipo === 'MONEDA') {
        const item: SelectItem = {
          label: r.nombre, value: r.codigo
        }
        this.ListaMonedaDP.push(item)
      }
      if (r.tipo === 'BAS') {
        const item: SelectItem = {
          label: r.nombre, value: r.codigo
        }
        this.ListaBaseDP.push(item)
      }
    })
    this.ListaFiltradaNombreEntidadesDP = this.ListaNombreEntidadesDP
    this.ListaFiltradaTipoEntidadDP = this.ListaTipoEntidadDP
  }

  async ngOnInit(): Promise<void> {
    this.fechaActual = new Date();
    this.groupPoppupDG = new FormGroup({
      codigo: new FormControl(null, null), activo: new FormControl(null, null),
      tipopersona: new FormControl("J", null), tipodocumento: new FormControl(null, null),
      numerodocumento: new FormControl(null, null), razonsocial: new FormControl(null, null),
      razoncomercial: new FormControl(null, null), nomgerente: new FormControl(null, null),
      fechanacimientog: new FormControl(null, null), fechaAniversariog: new FormControl(null, null),
      apellidopaterno: new FormControl(null, null), apellidomaterno: new FormControl(null, null),
      nombres: new FormControl(null, null), sexo: new FormControl(null, null),
      area: new FormControl(null, null), cargo: new FormControl(null, null),
      fechanacimiento: new FormControl(null, null), fechaingreso: new FormControl(null, null),
      correo: new FormControl(null, this.multiEmailTrimmedValidator), contactonombre: new FormControl(null, null),
      contactoapellidos: new FormControl(null, null), correoexport: new FormControl(null, this.multiEmailTrimmedValidator),
      direccion: new FormControl(null, null), pais: new FormControl(null, null),
      departamento: new FormControl(null, null), provincia: new FormControl(null, null),
      distrito: new FormControl(null, null), nodomiciliado: new FormControl(false, null),
    })
    this.groupPoppupD = new FormGroup({
      notas: new FormControl(null, null),
      cuentadeusuario: new FormControl(null, null)
    })
    this.group = new FormGroup({
      numdocumento: new FormControl(null, null), razonsocial: new FormControl(null, null)
    })
    this.groupPoppupE = new FormGroup({
      tipoentidad: new FormControl({ value: null, disabled: true }),
      numdocumento: new FormControl({ value: null, disabled: true }),
      razonsocial: new FormControl({ value: null, disabled: true })
    })
    this.ListarParametros()
  }

  search() {
    const loadingScreen = this.util.showLoadingScreen({ message: "Buscando datos ..." });
    const values = this.group.value
    const Request: ListarEntidadesRequest = <ListarEntidadesRequest>{}
    Request.pintENTC_Codigo = null
    Request.pvchENTC_NomCompleto = values['razonsocial']
    Request.pvchTIPE_Codigo = this.codigoEntidad
    Request.pvchENTC_DocIden = values['numdocumento']
    this.dataTable = []
    this.mantcomercial.ListarEntidades(Request).subscribe(response => {
      if (response.datos.status === 200) {
        this.dataTable = response.datos.result;
        loadingScreen.close();
      } else {
        loadingScreen.close();
        this.dataTable = []
        this.util.ShowMessage({ titulo: "ERROR", mensaje: "No se encontraron datos", icono: "pi pi-exclamation-triangle", tipo: "warning" });
      }
    }, err => {
      loadingScreen.close();
      this.dataTable = []
      this.util.ShowMessage({ titulo: err.error?.meta?.mensaje, tipo: 'warning', icono: 'pi pi-exclamation-triangle' });
    })
  }

  getDatosByRuc() {
    const values = this.groupPoppupDG.value
    const Request: ValidarDocIdentidadRequest = <ValidarDocIdentidadRequest>{}
    Request.pintENTC_Codigo = 0
    Request.pchrTIPO_TabTDI = 'TDI'
    Request.pchrTIPO_CodTDI = values['tipodocumento']
    Request.pvchENTC_DocIden = values['numerodocumento']
    this.mantcomercial.ValidarEntidadSunat(Request).subscribe(response => {
      if (response.datos.status === 200) {
        this.editEntidad('', response.datos.result[0])
        this.messageService.clear();
        this.messageService.add({ key: 'toast1', severity: 'success', summary: 'OK', detail: 'Se cargó la información correctamente.' });
      }
    }, (errorServicio => {
      const requestSunat: sunatRequest = <sunatRequest>{}
      requestSunat.razonsocial = values["razonSocial"]
      requestSunat.ruc = values["numerodocumento"]

      this.proformaService.listarSunat(requestSunat).subscribe(response => {
        if (response.datos.result.length > 0) {

          let sunatData = response.datos.result[0]
          if (values['tipopersona'] === 'N') {
            const nombresCompletos = sunatData.nombre_o_razon_social ? sunatData.nombre_o_razon_social.split(' ') : [];
            const apellidoPaterno = nombresCompletos.length > 0 ? nombresCompletos[0] : '';
            const apellidoMaterno = nombresCompletos.length > 1 ? nombresCompletos[1] : '';
            const nombres = nombresCompletos.length > 2 ? nombresCompletos.slice(2).join(' ') : '';
            this.groupPoppupDG.get('apellidopaterno')?.setValue(apellidoPaterno);
            this.groupPoppupDG.get('apellidomaterno')?.setValue(apellidoMaterno);
            this.groupPoppupDG.get('nombres')?.setValue(nombres);
          }
          
          const rawNombre = response.datos.result[0].nombre_o_razon_social || '';
          const nombre_o_razon_social = rawNombre.replace(/\\/g, '');
          this.groupPoppupDG.get('razonsocial').setValue(nombre_o_razon_social)
          this.groupPoppupDG.get('direccion').setValue(response.datos.result[0].direccion_completa)
          // asignar pais departamento distrito y provincia
          const ubigeo = response.datos.result[0].ubigeo;
          const ubigeoFormateado = ubigeo?.length === 6 ? ubigeo?.slice(0, 2) + '.' + ubigeo?.slice(2, 4) + '.' + ubigeo?.slice(4, 6) : ubigeo;
          const tipo_codpais = "179"; // peru por default
          const pai = this.listPais.find(r => r.codigo.toUpperCase() === tipo_codpais.toUpperCase())?.codigo
          this.groupPoppupDG.get('pais')?.setValue(pai);
          const partes = ubigeoFormateado?.split(".");
          const departamento = partes?.[0] ?? null;
          const provincia = partes?.[0] && partes?.[1] ? `${partes[0]}.${partes[1]}` : null;
          const distrito = ubigeoFormateado ?? null;
          this.onPaisSeleccionado(pai, 'INI')
          this.groupPoppupDG.get('departamento')?.setValue(departamento);
          this.onDepartamentoSeleccionado(departamento, 'INI')
          this.groupPoppupDG.get('provincia')?.setValue(provincia);
          this.onprovinciaSeleccionada(provincia, 'INI')
          this.groupPoppupDG.get('distrito')?.setValue(distrito);
          this.messageService.clear();
          this.messageService.add({ key: 'toast1', severity: 'success', summary: 'OK', detail: 'El documento de identidad se encuentra registrado en SUNAT.' });
        }
      }, (errorServicio2 => {
        this.messageService.clear();
        this.messageService.add({ key: 'toast2', severity: 'error', summary: 'Error', detail: 'El documento de identidad no se encuentra registrado en SUNAT, por favor verifique.' });
      }))
    }))
  }

  validarDocumento() {
    const values = this.groupPoppupDG.value
    const documento = this.groupPoppupDG.get('tipodocumento')?.value;
    if (documento === '001' || documento === '002') {
      switch (documento) {
        case '001':
          if (documento != '' && documento != null) this.getDatosByRuc();
          break;
        case '002':
          if (documento != '' && documento != null) this.getDatosByDni(values['numerodocumento']);
          break;
        default:
          break;
      }
    }
  }

  getDatosByDni(documentos: string) {
    const values = this.groupPoppupDG.value
    const Request: ValidarDocIdentidadRequest = <ValidarDocIdentidadRequest>{}
    Request.pintENTC_Codigo = 0;
    Request.pchrTIPO_TabTDI = 'TDI';
    Request.pchrTIPO_CodTDI = this.groupPoppupDG.get('tipodocumento')?.value;
    Request.pvchENTC_DocIden = values['numerodocumento'];
    this.mantcomercial.ValidarEntidadSunat(Request).subscribe(response => {
      if (response.datos.status === 200) {
        this.editEntidad('', response.datos.result[0])
        this.messageService.clear();
        this.messageService.add({ key: 'toast1', severity: 'success', summary: 'OK', detail: 'Se cargó la información correctamente.' });
      }
    }, (errorServicio => {
      this.proformaService.consultaDNI({ dni: documentos, token: null }).subscribe({
        next: (response) => {
          if (response.datos.status === 200) {
            this.messageService.clear();
            this.messageService.add({
              key: 'toast1', severity: 'success', summary: 'RENIEC',
              detail: 'El documento de identidad se encuentra registrado en RENIEC.'
            });
            const dniData = response.datos.result[0];
            const nombresCompletos = dniData.nombre_completo ? dniData.nombre_completo.split(' ') : [];
            const apellidoPaterno = nombresCompletos.length > 0 ? nombresCompletos[0] : '';
            const apellidoMaterno = nombresCompletos.length > 1 ? nombresCompletos[1] : '';
            const nombres = nombresCompletos.length > 2 ? nombresCompletos.slice(2).join(' ') : '';
            this.groupPoppupDG.get('apellidopaterno')?.setValue(apellidoPaterno);
            this.groupPoppupDG.get('apellidomaterno')?.setValue(apellidoMaterno);
            this.groupPoppupDG.get('nombres')?.setValue(nombres);
          }
        },
        error: (err) => {
          if (err.error.datos.status === 404) {
            this.messageService.clear();
            this.messageService.add({
              key: 'toast2', severity: 'error', summary: 'Error',
              detail: 'El documento de identidad no se encuentra registrado en RENIEC, por favor verifique.'
            });
          }
        }
      });
    }))
  }

  onChangeTipoDocumento(tipo: string, valor: any) {
    let tipo_doc;
    if (tipo === 'EVE') {
      tipo_doc = valor?.value ?? null;
    } else if (tipo === 'INI') {
      tipo_doc = valor;
    }
    if (tipo_doc === '002') {
      this.natural = true;
      this.juridica = false;
      this.groupPoppupDG.get('tipopersona').setValue("N");
    } else if (tipo_doc === '001') {
      this.juridica = true;
      this.natural = false;
      this.groupPoppupDG.get('tipopersona').setValue("J");
    }
  }

  verInputs(event) {
    const values = this.groupPoppupDG.value
    if (event === 'J' || values.tipopersona === 'J') {
      this.juridica = true, this.natural = false
    } else if (event === 'N') {
      this.juridica = false, this.natural = true
    }
  }

  codpai: number
  onPaisSeleccionado(event: any, tipo: string) {
    let valor;
    if (tipo == 'EVE') {
      valor = event.value;
    } else if (tipo == 'INI') {
      valor = event;
    }
    if (valor != null) {
      const request: ListarUbigeosRequest = <ListarUbigeosRequest>{}
      request.pvchUBIG_Codigo = null
      request.pchrTIPO_CodPais = valor;
      request.pchrTIPO_TabPais = 'PAI'
      this.mantcomercial.ListarUbigeos(request).subscribe(response => {
        const departamento = response.datos.result.filter(item => item.ubiG_CodPadre === null);
        this.listDepartamento = departamento;
      },
        err => {
          this.listDepartamento = [];
          this.listProvincia = [];
          this.listDistrito = [];
        });
    } else {
      this.listDepartamento = [];
      this.listProvincia = [];
      this.listDistrito = [];
    }
  }
  onDepartamentoSeleccionado(event: any, tipo: string) {
    let valor;
    if (tipo == 'EVE') {
      valor = event.value;
    } else if (tipo == 'INI') {
      valor = event;
    }
    if (valor != null) {
      const departamentoSeleccionado = valor;
      const request: ListarUbigeosRequest = <ListarUbigeosRequest>{}
      request.pvchUBIG_Codigo = null
      request.pchrTIPO_CodPais = this.groupPoppupDG.get('pais').value;
      request.pchrTIPO_TabPais = 'PAI'
      this.mantcomercial.ListarUbigeos(request).subscribe(response => {
        const provincias = response.datos.result.filter(item => item.ubiG_CodPadre === departamentoSeleccionado);
        this.listProvincia = provincias;
      }, err => { this.listProvincia = []; });
    } else {
      this.listProvincia = [];
    }
  }
  onprovinciaSeleccionada(event: any, tipo: string) {
    let valor;
    if (tipo == 'EVE') {
      valor = event.value;
    } else if (tipo == 'INI') {
      valor = event;
    }
    if (valor != null) {
      const provinciaseleccionada = valor;
      const request: ListarUbigeosRequest = <ListarUbigeosRequest>{}
      request.pvchUBIG_Codigo = null
      request.pchrTIPO_CodPais = this.groupPoppupDG.get('pais').value;
      request.pchrTIPO_TabPais = 'PAI'
      this.mantcomercial.ListarUbigeos(request).subscribe(response => {
        const distritos = response.datos.result.filter(item => item.ubiG_CodPadre === provinciaseleccionada);
        this.listDistrito = distritos;
      },
        err => {
          this.listDistrito = [];
        });
    } else {
      this.listDistrito = [];
    }
  }

  nuevo() {
    this.estadoEditar = false;
    this.visiblebtn = true
    this.visible = true
    this.entcCod = 0
    this.dataTableAuditoria = []
    this.uploadedFiles = []
    this.dataTableArchivos = []
    this.groupPoppupDG.reset()
    this.groupPoppupD.reset()
    this.groupPoppupDG.get('tipopersona').setValue("J")
    this.groupPoppupE.reset()
    this.listaDatosEntidad = [];
    this.groupPoppupDG.get('activo').setValue(true)
    this.groupPoppupDG.get('nodomiciliado').setValue(false);
  }

  listadoEdit(entcCodigo) {
    const RequestAU: ListarAuditoriaRequest = <ListarAuditoriaRequest>{}
    RequestAU.pintENTC_Codigo = entcCodigo
    this.dataTableAuditoria = []
    this.mantcomercial.ListarAuditoria(RequestAU).subscribe(response => {
      if (response.datos.status === 200) { this.dataTableAuditoria = response.datos.result }
    })
    const RequestAR: ListarArchivoEntidadRequest = <ListarArchivoEntidadRequest>{}
    RequestAR.ENAR_Codigo = 0
    RequestAR.ENTC_Codigo = entcCodigo
    this.uploadedFiles = []
    this.mantcomercial.ListarArchivosEntidad(RequestAR).subscribe(response => {
      if (response.datos.status === 200) {
        this.dataTableArchivos = response.datos.result
        this.uploadedFiles = this.dataTableArchivos.map(r => ({
          codigo: r.enaR_Codigo, tipotran: 'U', image: null, usuario: r.audI_UsrCrea, fecha: r.audI_FecCrea, nombre: r.enaR_NombreArchivo
        }))
      }
    })
    const RequestDO: ConsultarDireccionEntidadRequest = <ConsultarDireccionEntidadRequest>{}
    RequestDO.pintENTC_Codigo = entcCodigo
    this.dataTableDireccion = []
    this.mantcomercial.ConsultarDireccionEntidad(RequestDO).subscribe(response => {
      if (response.datos.status === 200) {
        this.dataTableDireccion = response.datos.result
        this.dataTableDireccion.forEach(row => {
          if (row && row.dirE_Codigo === 1) {
            this.groupPoppupDG.get('direccion')?.setValue(row.dirE_Direccion);
            const pai = this.listPais.find(r => r.codigo.toUpperCase() === row.tipO_CodPais.toUpperCase())?.codigo
            this.groupPoppupDG.get('pais')?.setValue(pai);
            const partes = row.ubiG_Codigo?.split(".");
            const departamento = partes?.[0] ?? null;
            const provincia = partes?.[0] && partes?.[1] ? `${partes[0]}.${partes[1]}` : null;
            const distrito = row.ubiG_Codigo ?? null;
            this.onPaisSeleccionado(pai, 'INI')
            this.groupPoppupDG.get('departamento')?.setValue(departamento);
            this.onDepartamentoSeleccionado(departamento, 'INI')
            this.groupPoppupDG.get('provincia')?.setValue(provincia);
            this.onprovinciaSeleccionada(provincia, 'INI')
            this.groupPoppupDG.get('distrito')?.setValue(distrito);
          }
        });
      }
    })
  }

  correoface: string
  telfijo: string
  telmovil: string
  web: string
  editEntidad(value, row: any) {
    this.estadoEditar = true;
    this.listaDatosEntidad = row;
    this.visible = true
    this.visiblebtn = false
    this.dataTableAuditoria = []
    this.dataTableArchivos = []
    this.uploadedFiles = []
    this.groupPoppupDG.reset()
    this.groupPoppupD.reset()
    this.groupPoppupE.reset()
    this.groupPoppupDG.get('tipopersona').setValue("J")
    if (row) {
      //DATOS GENERALES
      this.entcCod = row.entC_Codigo
      this.correoface = row.entC_EmailReceptorFE
      this.telfijo = row.entC_Telef1
      this.telmovil = row.entC_Telef2
      this.web = row.entC_Web
      this.listadoEdit(row.entC_Codigo)
      if (row.entC_Codigo) { this.groupPoppupDG.get('codigo').setValue(row.entC_Codigo) }
      if (row.entC_Activo) { this.groupPoppupDG.get('activo').setValue(row.entC_Activo) }
      if (row.entC_TipEnt) { this.groupPoppupDG.get('tipopersona').setValue(row.entC_TipEnt) }
      if (row.tipO_CodTDI) {
        const td = this.ListaTodosTipoDoc.find(r => r.codigo.toUpperCase() === row.tipO_CodTDI.toUpperCase())?.codigo
        this.groupPoppupDG.get('tipodocumento').setValue(td)
        this.onChangeTipoDocumento('INI', td);
      }
      if (row.entC_DocIden) { this.groupPoppupDG.get('numerodocumento').setValue(row.entC_DocIden) }
      if (row.entC_RazonSocial) { this.groupPoppupDG.get('razonsocial').setValue(row.entC_RazonSocial) }
      if (row.entC_NomComercial) { this.groupPoppupDG.get('razoncomercial').setValue(row.entC_NomComercial) }
      if (row.nombreGerente) { this.groupPoppupDG.get('nomgerente').setValue(row.nombreGerente) }
      if (row.fechaNacimiento) { this.groupPoppupDG.get('fechanacimientog').setValue(new Date(row.fechaNacimiento)) }
      if (row.fechaAniversario) { this.groupPoppupDG.get('fechaAniversariog').setValue(new Date(row.fechaAniversario)) }
      if (row.entC_ApePat) { this.groupPoppupDG.get('apellidopaterno').setValue(row.entC_ApePat) }
      if (row.entC_ApeMat) { this.groupPoppupDG.get('apellidomaterno').setValue(row.entC_ApeMat) }
      if (row.entC_Nombres) { this.groupPoppupDG.get('nombres').setValue(row.entC_Nombres) }
      if (row.entC_Sexo) { this.groupPoppupDG.get('sexo').setValue(row.entC_Sexo) }
      if (row.entC_Area) { this.groupPoppupDG.get('area').setValue(row.entC_Area) }
      if (row.entC_Cargo) { this.groupPoppupDG.get('cargo').setValue(row.entC_Cargo) }
      if (row.entC_FecNac) { this.groupPoppupDG.get('fechanacimiento').setValue(new Date(row.entC_FecNac)) }
      if (row.entC_FecIng) { this.groupPoppupDG.get('fechaingreso').setValue(new Date(row.entC_FecIng)) }
      if (row.entC_EMail) { this.groupPoppupDG.get('correo').setValue(row.entC_EMail) }
      if (row.entC_NombreContacto) { this.groupPoppupDG.get('contactonombre').setValue(row.entC_NombreContacto) }
      if (row.entC_ApellidoContacto) { this.groupPoppupDG.get('contactoapellidos').setValue(row.entC_ApellidoContacto) }
      if (row.entC_Obser) { this.groupPoppupDG.get('observaciones').setValue(row.entC_Obser) }
      if (row.entC_Domiciliado) { this.groupPoppupDG.get('nodomiciliado').setValue(row.entC_Domiciliado) }
      if (row.tipE_Codigo) { this.groupPoppupE.get('tipoentidad').setValue(row.tipE_Codigo.toString()) }
      if (row.entC_DocIden) { this.groupPoppupE.get('numdocumento').setValue(row.entC_DocIden) }
      if (row.entC_RazonSocial) { this.groupPoppupE.get('razonsocial').setValue(row.entC_RazonSocial) }

      //DATOS
      if (row.entC_Notas) { this.groupPoppupD.get('notas').setValue(row.entC_Notas) }
      if (row.entC_CuentaDetraccion) { this.groupPoppupD.get('cuentadeusuario').setValue(row.entC_CuentaDetraccion) }
    }
  }

  uploadedFiles: any[] = [];
  onUpload(event) {
    if (event.files.length > 0) {
      for (let file of event.files) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const base64Data = (e.target.result as string).split(',')[1];
          const req = {
            items: [{
              codigo: 0,
              tipotran: 'I',
              image: URL.createObjectURL(file),
              usuario: this.storage.get('usuario'),
              fecha: this.util.formatearfecha(new Date(), 'dd-mm-yyyy'),
              nombre: file.name,
              url: base64Data
            }]
          }

          this.uploadedFiles.push({
            codigo: req.items[0].codigo,
            tipotran: req.items[0].tipotran,
            image: req.items[0].image,
            usuario: req.items[0].usuario,
            fecha: req.items[0].fecha,
            nombre: req.items[0].nombre,
            url: req.items[0].url
          });

          this.uploadedFiles = [...this.uploadedFiles]
        }
        reader.readAsDataURL(file);
      }
    }
  }

  obtenerIconoTipoArchivo(nombreArchivo: string): string {
    const extension = nombreArchivo.split('.').pop()?.toLowerCase();
    switch (extension) {
      case 'pdf':
        return '../../../../../assets/iconos/pdf.svg';
      case 'doc':
        return '../../../../../assets/iconos/documento.svg'
      case 'docx':
        return '../../../../../assets/iconos/word.svg'
      case 'jpg':
        return '../../../../../assets/iconos/jpg.svg'
      case 'jpeg':
      case 'png':
        return 'assets/icons/image-icon.svg';
      case 'xls':
        return '../../../../../assets/iconos/excel.svg'
      case 'xlsx':
        return '../../../../../assets/iconos/excel.svg'
      default:
        return 'assets/icons/default-icon.svg';
    }
  }

  downloadArchivo(value, row: any) {
    if (!row.url) {
      console.error('No hay archivo disponible para descargar.');
      return;
    }
    const extension = row.nombre.split('.').pop();
    const mimeType = this.getMimeType(extension);
    const fileName = `${row.nombre}.${extension}`;

    const byteCharacters = atob(row.url);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: mimeType });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();

    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }

  getMimeType(extension: string): string {
    const mimeTypes: { [key: string]: string } = {
      'png': 'image/png',
      'jpg': 'image/jpeg',
      'jpeg': 'image/jpeg',
      'gif': 'image/gif',
      'pdf': 'application/pdf',
      'txt': 'text/plain',
      'doc': 'application/msword',
      'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'xls': 'application/vnd.ms-excel',
      'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'zip': 'application/zip',
    };

    return mimeTypes[extension.toLowerCase()] || 'application/octet-stream';
  }

  deleteArchivo(row) {
    if (row) { row.tipotran = 'D'; }
  }

  ListaTranEntidad: TablaEntidadBloqueo[] = []
  ListaTranDirecEntidad: TablaDireccionEntidad[] = []
  async TransaccionEntidad(accion, row) {
    const tnsValida = await this.validarTransaccion();
    const emailValido = await this.validarEmail();
    const direccionValida = await this.validarDirecciones();
    if ((tnsValida == false || emailValido == false || direccionValida == false) && accion !== 'D') { return; }

    row = this.listaDatosEntidad
    const values = this.groupPoppupDG.value
    const valuesdatos = this.groupPoppupD.value
    const RequestTrans: TransaccionEntidadBloqueoRequest = <TransaccionEntidadBloqueoRequest>{}
    RequestTrans.tablaDireccionEntidad = []
    const items = <TablaDireccionEntidad>{}
    items.ENTC_Codigo = this.entcCod || 0
    if (accion === 'I') {
      items.DIRE_Codigo = 0
    } else { items.DIRE_Codigo = 1 }
    items.DIRE_Direccion = values.direccion
    items.DIRE_Facturar = true
    items.DIRE_Referencia = null
    items.DIRE_Activo = true
    items.UBIG_Codigo = values.distrito
    items.TIPO_TabPais = 'PAI'
    items.TIPO_CodPais = values.pais
    items.AUDI_UsrCrea = this.storage.get('usuario')
    items.AUDI_UsrMod = this.storage.get('usuario')
    if (accion === 'I') {
      items.tipotran = 'I';
    } else if (accion === 'U') {
      if (values.direccion) {
        const direccionEnBD = this.dataTableDireccion.some(row => row && row.dirE_Codigo === 1);
        if (!direccionEnBD) {
          items.tipotran = 'I';
        } else {
          items.tipotran = 'U';
        }
      } else {
        items.tipotran = 'D';
      }
    }
    RequestTrans.tablaDireccionEntidad.push(items)
    RequestTrans.tablaEntidadBloqueo = []
    const itement = <TablaEntidadBloqueo>{}
    itement.ENTC_Codigo = this.entcCod || 0
    itement.TIPO_TabTDI = 'TDI'
    itement.TIPO_CodTDI = values.tipodocumento
    itement.ENTC_TipEnt = values.tipopersona
    itement.ENTC_DocIden = values.numerodocumento
    itement.ENTC_Domiciliado = values.nodomiciliado || false
    itement.ENTC_Nombres = values.nombres
    itement.ENTC_ApePat = values.apellidopaterno
    itement.ENTC_ApeMat = values.apellidomaterno
    if (values.apellidopaterno && values.nombres) {
      itement.ENTC_NomCompleto = `${itement.ENTC_ApePat || ''} ${itement.ENTC_ApeMat || ''} ${itement.ENTC_Nombres || ''}`.trim();
    } else if (values.razoncomercial) {
      itement.ENTC_NomCompleto = values.razoncomercial;
    } else if (values.razonsocial) {
      itement.ENTC_NomCompleto = values.razonsocial;
    } else { itement.ENTC_NomCompleto = null }
    itement.ENTC_NomComercial = values.razoncomercial
    itement.ENTC_RazonSocial = values.razonsocial
    itement.ENTC_Activo = values.activo || false
    itement.ENTC_FecNac = values.fechanacimiento
    itement.ENTC_FecIng = values.fechaingreso
    itement.ENTC_VIP = values.vip || false
    itement.ENTC_Notas = valuesdatos.notas
    itement.ENTC_Sexo = values.sexo
    itement.ENTC_EMail = values.correo
    itement.ENTC_Web = this.web
    itement.ENTC_Propio = false
    itement.ENTC_Telef1 = this.telfijo
    itement.ENTC_Telef2 = this.telmovil
    itement.ENTC_Telef3 = null
    itement.ENTC_Telef4 = null
    itement.ENTC_Beneficiario = valuesdatos.beneficiario
    itement.ENTC_Area = values.area
    itement.ENTC_Cargo = values.cargo
    itement.USER_CodUsr = ''
    itement.TIPO_TabPai = 'PAI'
    itement.TIPO_CodPai = values.pais
    itement.TIPO_TabHol = null
    itement.TIPO_TabHol = null
    itement.CONS_CodTFT = null
    itement.CONS_TabTFT = 'TFT'
    itement.TIPO_TabCiu = null
    itement.TIPO_CodCiu = null
    itement.ENTC_Prospecto = values.prospecto || false
    itement.TIPO_TabDTM = null
    itement.TIPO_CodDTM = null
    itement.ENTC_ValRebate = null
    itement.TIPO_TabMnd = 'MND'
    itement.TIPO_CodMnd = null
    itement.ENTC_ValTarja = null
    itement.ENTC_DiasCredito = null
    itement.ENTC_FechaCredito = null
    itement.ENTC_Tarja = false
    itement.ENTC_CodAduana = null
    itement.CONS_CodCre = null
    itement.CONS_TabCre = null
    itement.ENTC_EMail2 = values.correo
    itement.ENTC_Obser = values.observaciones
    itement.ENTC_InterbancarioSol = null
    itement.ENTC_InterbancarioDol = null
    itement.ENTC_CuentaDetraccion = values.cuentadeusuario
    itement.ENTC_ServicioLogistico = false
    itement.ENTC_OcultarShipper = false
    itement.ENTC_ObsFinanzasCliente = null
    itement.ENTC_BloqueoFinanzasCliente = false
    itement.ENTC_UsrBloqueoCliente = null
    itement.ENTC_FecBloqueoCliente = null
    itement.ENTC_EmailFinanzas = null
    itement.ENTC_ObsBloqueoCliente = null
    itement.ENTC_OtrosTraficos = false
    itement.ENTC_Mandato = false
    itement.ENTC_SLI = false
    itement.ENTC_Exportacion = false
    itement.ENTC_UsrBloqueoProveedor = null
    itement.ENTC_FecBloqueoProveedor = null
    itement.ENTC_BloqueoFinanzasProveedor = false
    itement.ENTC_ObsFinanzasProveedor = null
    itement.ENTC_ObsBloqueoProveedor = null
    itement.ENTC_ProvAsumeDetraccion = false
    itement.ENTC_ToOrder = false
    itement.AUDI_UsrCrea = this.storage.get('usuario')
    itement.AUDI_UsrMod = this.storage.get('usuario')
    itement.ENTC_EmailReceptorFE = this.correoface
    itement.TIPO_CodSEG = null
    itement.ENTC_NombreContacto = values.contactonombre
    itement.ENTC_ApellidoContacto = values.contactoapellidos
    itement.ENTC_CorreoContactoExpo = values.correoexport
    itement.nombreGerente = values.nomgerente
    itement.fechaNacimiento = values.fechanacimientog
    itement.fechaAniversario = values.fechaAniversariog
    itement.ENTC_Siglas = row['entc_siglas'] || null

    RequestTrans.tablaEntidadBloqueo.push(itement)
    RequestTrans.TIPE_Codigo = this.codigoEntidad
    RequestTrans.DIRE_Facturar = true
    RequestTrans.ENTC_Codigo = row.entC_Codigo != null ? row.entC_Codigo : values['codigo']
    RequestTrans.operacion = accion

    this.InsertArchivos = this.uploadedFiles.map(item => ({
      ENAR_Codigo: item.codigo,
      ENTC_Codigo: this.entcCod,
      ENAR_Archivo: item.url,
      AUDI_UsrCrea: item.usuario,
      ENAR_NombreArchivo: item.nombre,
      ENAR_Extension: '.' + item.nombre.split('.').pop(),
      ID_OUT: 0,
      tipotran: item.tipotran
    }))

    RequestTrans.tablalimitecredito = [];
    RequestTrans.tablacuentasbancarias = [];
    RequestTrans.tablaarchivosentidad = this.InsertArchivos
    RequestTrans.tabladetalleservicio = [];
    RequestTrans.tablazonatransporte = [];
    RequestTrans.tablatipocarga = [];
    RequestTrans.tablaserviciosentidad = [];
    RequestTrans.tablaEntidadRelacionados = [];

    this.mantcomercial.TransaccionEntidadBloqueo(RequestTrans).subscribe(response => {
      if (response.datos.status === 200) {
        this.util.ShowMessage({ titulo: '', mensaje: response?.meta?.mensaje, tipo: 'ok' })
        this.visible = false
        const razonsocial = this.group.get('razonsocial').value;
        const numdocumento = this.group.get('numdocumento').value;
        if (razonsocial != null || razonsocial != '' || numdocumento != null || numdocumento != '') { this.search(); }
      }
    }, err => {
      this.messageService.add({ key: 'toast1', severity: 'error', summary: 'Error', detail: err?.error?.meta?.mensaje });
    })
  }

  salir() {
    this.visible = false
  }

  exportExcel() {
    if (this.dataTable.length == 0) { this.util.showMessageError('No hay datos para exportar'); return; }
    let nuevadata = []
    this.dataTable.forEach(row => {
      const {
        entC_Codigo,
        tipO_CodTDI,
        entC_DocIden,
        entC_RazonSocial,
        entC_Activo,
        entC_EMail,
        entC_EmailReceptorFE,
        entC_Telef1,
        entC_Telef2,
        entC_CodSAP_C,
        entC_CodSAP_P,
        entC_FecActSAP,
        audI_UsrCrea,
        audI_FecCrea,
        audI_UsrMod,
        audI_FecMod
      } = row;
      const newItem = {
        "CÓDIGO": entC_Codigo,
        "TIPO DOC. IDENTIDAD": tipO_CodTDI,
        "N.I.T": entC_DocIden,
        "NOMBRE": entC_RazonSocial,
        "ACTIVO": entC_Activo === true ? 'SI' : 'NO',
        "CORREO": entC_EMail,
        "CORREO FACTURA ELECTRÓNICA": entC_EmailReceptorFE,
        "TEL. FIJO": entC_Telef1,
        "TEL. MÓVIL": entC_Telef2,
        "CLIENTE SAP": entC_CodSAP_C,
        "PROVEEDOR SAP": entC_CodSAP_P,
        "SINCRONIZACIÓN SAP": this.util.formatearfecha(entC_FecActSAP, 'dd-mm-yyyy'),
        "CREADO POR": audI_UsrCrea,
        "FECHA CREA": this.util.formatearfecha(audI_FecCrea, 'dd-mm-yyyy'),
        "MODIFICADO POR": audI_UsrMod,
        "FECHA MOD.": this.util.formatearfecha(audI_FecMod, 'dd-mm-yyyy')
      };
      nuevadata.push(newItem);
    });

    const data = [
      {
        data: nuevadata, cabeceras: []
      }
    ]
    this.util.ExportarExcel(data, 'MANTENIMIENTO CUSTOMER SERVICE.xlsx')
  }

  salirBandejaPrincipal() {
    const rutaComponente = '/mantenimiento-comercial';
    this.router.navigate([rutaComponente]);
  }

  sincronizarSAP(row) {
    this.util.ShowMessage({
      titulo: "Sincronizar SAP",
      mensaje: "Seleccionar Tipo Socio de Negocio (SAP)",
      tipo: 'error',
      textoBtn: {
        textoBtnOpcion1: "Cliente",
        textoBtnOpcion2: "Proveedor",
      },
      pregunta: {
        onAccept: () => {
          this.funcionSincronizarSAP(row.row, 'C')
          return;
        },
        onReject: () => {
          this.funcionSincronizarSAP(row.row, 'P')
          return;
        },
      }
    });
  }

  funcionSincronizarSAP(row: any, tipoSocio: string) {
    this.metadataTable[0].loading = true;
    const loadingScreen = this.util.showLoadingScreen({ message: "Sincronizando ..." });
    const Request: SincronizarEntidadSapRequest = <SincronizarEntidadSapRequest>{}
    Request.ENTC_Codigo = row.entC_Codigo
    Request.TIPE_Codigo = row.tipE_Codigo
    Request.TipoSocio = tipoSocio
    this.mantcomercial.SincronizarEntidadSAP(Request).subscribe(response => {
      if (response.datos.status === 200) {
        this.util.ShowMessage({ titulo: "Sincronización Exitosa", mensaje: response.meta.mensajeRespuesta, icono: "OK", tipo: "ok" });
        this.metadataTable[0].loading = false;
        this.search();
        loadingScreen.close();
      } else {
        this.util.ShowMessage({ titulo: "ERROR", mensaje: response.meta.mensajeRespuesta, icono: "pi pi-exclamation-triangle", tipo: "warning" });
        this.metadataTable[0].loading = false;
        loadingScreen.close();
      }
    }, err => {
      this.util.ShowMessage({ titulo: "ERROR", mensaje: err?.error?.meta?.mensaje, icono: "pi pi-exclamation-triangle", tipo: "warning" });
      loadingScreen.close();
      this.metadataTable[0].loading = false;
    })
  }
  InsertArchivos: any[] = []
  dataButtons = [
    { icon: 'pi pi-download', function: () => this.exportAuditoria() }
  ];
  exportAuditoria() {
    if (this.dataTableAuditoria.length == 0) { this.util.showMessageError('No hay datos para exportar'); return; }
    let nuevadata = []
    this.dataTableAuditoria.forEach(row => {
      const { operacion, direccionip, nombremaquina, nombreaplicacion, usuariosql, usuarioaplicacion, fechamodificacion, codigoentidad, docidentidad,
        codigodocidentidad, numdocidentidad, tipopersona, domiciliado, nombres, apellidopaterno, apellidomaterno, nombrecompleto, nombrecomercial,
        razonsocial, activo, fechanacimiento, fechaingreso, vip, notas, sexo, email, email2, web, propio, telefono1, telefono2, telefono3, telefono4,
        beneficiario, area, cargo, cuentausuario, pais, codigopais, holding, codigoholding, tipotarifa, codigotarifa, prospecto, rebate, moneda,
        codigomoneda, tipodeposito, codtipodeposito, tarja, realizatarja, diacredito, fechacredito, codigoaduana, observaciones, cuenintersoles,
        cueninterdolares, cuendetraccion, serviciologistico, ocultarshipper, obserfinanzas, otrostraficos, mandato, sli, exportacion, emailfinanzas,
        bloqueocliente, usubloqueacliente, fecbloqueocliente, obserbloqueocliente, bloqueoproveedor, usubloqueaproveedor, fecbloqueoproveedor,
        obserbloqueoproveedor, obserproveedor, asumedetraccion, usuariocrea, fechacrea, usuariomodifica, fechamodifica
      } = row;
      const newItem = {
        "Operación": operacion,
        "Dirección IP": direccionip,
        "Nombre Máquina": nombremaquina,
        "Nombre Apliación": nombreaplicacion,
        "Usuario SQL": usuariosql,
        "Usuario Aplicación": usuarioaplicacion,
        "Fecha Modificación": fechamodificacion || '',
        "Código Entidad": codigoentidad || '',
        "Doc. Identidad": docidentidad || '',
        "Código Doc. Identidad": codigodocidentidad || '',
        "Num. Doc. Identidad": numdocidentidad || '',
        "Tipo Persona": tipopersona || '',
        "Domiciliado": domiciliado === true ? 'SI' : 'NO',
        "Nombres": nombres || '',
        "Ape. Paterno": apellidopaterno || '',
        "Ape. Materno": apellidomaterno || '',
        "Nom. Completo": nombrecompleto || '',
        "Nom. Comercial": nombrecomercial || '',
        "Razón Social": razonsocial || '',
        "Activo": activo === true ? 'SI' : 'NO',
        "Fec. Nacimiento": fechanacimiento,
        "Fec. Ingreso": fechaingreso,
        "VIP": vip === true ? 'SI' : 'NO',
        "Notas": notas,
        "Sexo": sexo,
        "E-mail": email,
        "E-mail2": email2,
        "Web": web,
        "Propio": propio,
        "Teléfono 1": telefono1,
        "Teléfono 2": telefono2,
        "Teléfono 3": telefono3,
        "Teléfono 4": telefono4,
        "Beneficiario": beneficiario,
        "Área": area,
        "Cargo": cargo,
        "Cuenta Usuario": cuentausuario,
        "País": pais,
        "Cod. País": codigopais,
        "Holding": holding,
        "Cod. Holding": codigoholding,
        "Tipo Tarifa": tipotarifa,
        "Cod. Tarifa": codigotarifa,
        "Prospecto": prospecto === true ? 'SI' : 'NO',
        "Rebate": rebate,
        "Moneda": moneda,
        "Cod. Moneda": codigomoneda,
        "Tipo Depósito": tipodeposito,
        "Cod. Tipo Depósito": codtipodeposito,
        "Tarja": tarja,
        "Reaiza Tarja": realizatarja === true ? 'SI' : 'NO',
        "Día Crédito": diacredito,
        "Fec. Crédito": fechacredito,
        "Cod. Aduana": codigoaduana,
        "Observaciones": observaciones,
        "Cuen. Inter. Soles": cuenintersoles,
        "Cuen. Inter. Dólares": cueninterdolares,
        "Cuen. Detracción": cuendetraccion,
        "Servicio Logístico": serviciologistico === true ? 'SI' : 'NO',
        "Ocultar Shipper": ocultarshipper === true ? 'SI' : 'NO',
        "Obser. Finanzas": obserfinanzas,
        "Otros Tráficos": otrostraficos === true ? 'SI' : 'NO',
        "Mandato": mandato === true ? 'SI' : 'NO',
        "SLI": sli === true ? 'SI' : 'NO',
        "Exportación": exportacion === true ? 'SI' : 'NO',
        "E-mail Finanzas": emailfinanzas,
        "Bloqueo Cliente": bloqueocliente === true ? 'SI' : 'NO',
        "Usu. Bloquea Cliente": usubloqueacliente,
        "Fec. Bloqueo Cliente": fecbloqueocliente,
        "Obser. Bloqueo Cliente": obserbloqueocliente,
        "Bloqueo Proveedor": bloqueoproveedor === true ? 'SI' : 'NO',
        "Usu. Bloquea Proveedor": usubloqueaproveedor,
        "Fec. Bloqueo Proveedor": fecbloqueoproveedor,
        "Obser. Bloqueo Proveedor": obserbloqueoproveedor,
        "Obser. Proveedor": obserproveedor,
        "Asume Detracción": asumedetraccion,
        "Usuario Crea": usuariocrea,
        "Fec. Crea": fechacrea,
        "Usuario Modifica": usuariomodifica,
        "Fec. Modifica": fechamodifica
      };
      nuevadata.push(newItem);
    });

    const data = [
      {
        data: nuevadata, cabeceras: []
      }
    ]
    this.util.ExportarExcel(data, 'AUDITORÍA CUSTOMER SERVICE.xlsx')
  }

  async validarTransaccion(): Promise<boolean> {
    let esValido = true;
    let mensajeError = "";

    const group = this.groupPoppupDG;
    const get = (campo: string) => group.get(campo)?.value;

    let controles = {
      // ENTC_Codigo: { requerido: get("ENTC_Codigo") == null, mensaje: "Debe ingresar el campo ENTC_Codigo" },
      TIPO_CodTDI: { requerido: !get("tipodocumento"), mensaje: "Debe seleccionar el campo tipo documento" },
      ENTC_TipEnt: { requerido: !get("tipopersona"), mensaje: "Debe ingresar el campo Tipo de Persona" },
      ENTC_DocIden: { requerido: !get("numerodocumento"), mensaje: "Debe ingresar el campo número de documento" },
      // ENTC_Domiciliado: { requerido: get("nodomiciliado") == null, mensaje: "Debe ingresar el campo No Domiciliado" },
      // ENTC_VIP: { requerido: get("vip") == null, mensaje: "Debe ingresar el campo VIP" },
    };

    if (this.natural) {
      const ctlr = { ENTC_Sexo: { requerido: !get("sexo"), mensaje: "Debe ingresar el campo Sexo" } };
      controles = { ...controles, ...ctlr };
    }

    // Validar campos básicos
    for (let campo in controles) {
      if (controles[campo].requerido) {
        group.get(campo)?.setErrors({ required: true });
        mensajeError += `* ${controles[campo].mensaje}\n`;
        esValido = false;
      } else {
        group.get(campo)?.setErrors(null);
      }
    }

    // Validar según tipo de entidad
    const tipEnt = get("tipopersona");
    if (tipEnt === "J") {
      if (!get("razonsocial")) {
        group.get("razonsocial")?.setErrors({ required: true });
        mensajeError += "* Debe ingresar el campo razón social\n";
        esValido = false;
      } else {
        group.get("razonsocial")?.setErrors(null);
      }
    } else {
      if (!get("nombres")) {
        group.get("nombres")?.setErrors({ required: true });
        mensajeError += "* Debe ingresar el campo nombre\n";
        esValido = false;
      } else {
        group.get("nombres")?.setErrors(null);
      }
    }

    // Validar crédito
    const diasCredito = get("diascreditos");
    const fechaCredito = get("fechacredito");

    if (diasCredito && diasCredito > 0 && !fechaCredito) {
      group.get("fechacredito")?.setErrors({ required: true });
      mensajeError += "* Debe ingresar el campo fecha crédito\n";
      esValido = false;
    } else {
      group.get("fechacredito")?.setErrors(null);
    }

    if (!diasCredito && fechaCredito) {
      group.get("diascreditos")?.setErrors({ required: true });
      mensajeError += "* Debe ingresar el campo días crédito\n";
      esValido = false;
    } else {
      group.get("diascreditos")?.setErrors(null);
    }

    if (!esValido) {
      this.messageService.add({ key: 'toast1', severity: 'error', summary: 'Completar campos obligatorios', detail: mensajeError });
    }

    return esValido;
  }

  async validarEmail(): Promise<boolean> {
    let l_correcto = true;
    let l_email1OK = true;
    let l_email2OK = true;
    let l_email3OK = true;

    let mensajeError = '';
    const delimiter = ';';

    // Validación de ENTC_EMail
    const ENTC_EMail = this.groupPoppupDG.get('correo')?.value;
    mensajeError = '';
    if (ENTC_EMail) {
      const correos = ENTC_EMail.split(delimiter);
      for (const correo of correos) {
        if (correo.trim() && !this.isValidEmail(correo.trim())) {
          l_email1OK = false;
        }
      }
      if (!l_email1OK) {
        mensajeError = 'El Formato del Correo es Incorrecto\n';
      }
    }

    if (!l_email1OK || !l_email2OK || !l_email3OK) {
      l_correcto = false;
      this.messageService.add({ key: 'toast1', severity: 'error', summary: 'El Formato de alguno de los correos ingresados es incorrecto', detail: mensajeError });
    }

    return l_correcto;
  }

  isValidEmail(emailList: string): boolean {
    const trimmed = (emailList || '').trim();
    if (!trimmed) return false;
    const emails = trimmed
      .split(/[\s,;]+/)
      .map(e => e.trim())
      .filter(e => e.length > 0);

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    return emails.every(e => emailRegex.test(e));
  }

  validarDirecciones(): boolean {
    let l_correcto = true;
    let l_direccionFiscal = true;
    let l_direccionComercial = true;
    let mensajeError = '';

    const DIRE_Direccion = this.groupPoppupDG.get('direccion')?.value;
    const pais = this.groupPoppupDG.get('pais')?.value;

    if (pais) {
      if (!DIRE_Direccion) {
        l_direccionFiscal = false;
      }
    }

    if (!l_direccionFiscal || !l_direccionComercial) {
      l_correcto = false;
      this.messageService.clear();
      this.messageService.add({ key: 'toast1', severity: 'error', summary: 'Campos obligatorios', detail: 'Debe ingresar una Dirección para poder guardar el registro' });
    }

    return l_correcto;
  }

  multiEmailTrimmedValidator(control: AbstractControl): ValidationErrors | null {
    const value = (control.value || '').trim();
    if (!value) return null;
    const emails = value
      .split(/[\s,;]+/)
      .map(email => email.trim())
      .filter(email => email.length > 0);
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    const allValid = emails.every(email => emailRegex.test(email));
    return allValid ? null : { email: true };
  }

  eliminar(row: any) {
    this.util.MessageDialog({
      titulo: 'Confirmación', mensaje: "¿Seguro que desea eliminar la entidad?", icono: "pi pi-exclamation-triangle", tipo: "warning",
      textoBtn: { textoBtnOpcion1: "Sí", textoBtnOpcion2: "No", },
      pregunta: { onAccept: () => { this.TransaccionEntidad('D', row); }, onReject: () => { return; } }
    })
    return;
  }
}
